import { BankOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, List, Modal, PageHeader, Typography } from 'antd'
import * as React from 'react'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { ContiCorrentiModel, ContoCorrenteModel } from '../../models/ConfigurazioneModels'

import { TTAvatar } from '../shared/TTAvatar'
import { ModalContoCorrente } from './ModalContoCorrente'

const { Text, Link } = Typography;


class PageContiCorrentiState extends ContiCorrentiModel {
    ModalVisible: boolean = false
    ModalData: ContoCorrenteModel
}

export class PageContiCorrenti extends React.Component<any, PageContiCorrentiState> {

    service: IConfigurazioneService

    constructor(props) {
        super(props)
        this.state = new PageContiCorrentiState()
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
    }

    componentDidMount() {
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.GetContiCorrenti()
        if (resp.IsValid == true)
            this.setState(resp)
    }

    onAddClick = () => {
        this.toggleModal(true)
    }

    onClick = (data: ContoCorrenteModel) => {
        this.toggleModal(true, data)
    }

    toggleModal = (visible: boolean, data?: ContoCorrenteModel) => {
        this.setState({ ModalVisible: visible, ModalData: data })
    }

    onDeleteClick = (id: string) => {
        Modal.confirm({
            title: "Elimina",
            content: "Eliminare il conto corrente?",
            onOk: async () => {
                let resp = await this.service.EliminaContoCorrente(id)
                if (resp.IsValid == true)
                    this.loadPage()
            }
        })
    }

    render() {
        return (
            <PageHeader title="Conti Correnti" extra={[
                <Button type="primary" key="add" icon={<PlusOutlined />} onClick={() => this.onAddClick()}>Aggiungi</Button>
            ]}>
                <List
                    dataSource={this.state.ContiCorrenti}
                    rowKey={it => it.Id}
                    pagination={false}
                    renderItem={item => (
                        item.Disabled
                            ? <List.Item key={item.Id}>
                                <List.Item.Meta
                                    avatar={<TTAvatar icon={<BankOutlined />} size="small" />}
                                    title={<Text disabled >{item.Descrizione}</Text >} />
                            </List.Item>

                            :<List.Item key={item.Id} extra={[
                                <Button type="link" icon={<DeleteOutlined />} key="elimina" size="small"
                                    onClick={() => this.onDeleteClick(item.Id)}>&nbsp;Elimina</Button>
                            ]}>
                                <List.Item.Meta
                                    avatar={<TTAvatar icon={<BankOutlined />} size="small" />}
                                    title={<a onClick={() => this.onClick(item)}>{item.Descrizione}</a>} />
                            </List.Item>
                    )} />

                {this.state.ModalVisible ?
                    <ModalContoCorrente
                        data={this.state.ModalData}
                        visible={this.state.ModalVisible}
                        closeModal={() => this.toggleModal(false)}
                        do={() => this.loadPage()} /> : <></>
                }
            </PageHeader>
        )
    }
}